import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledEmptyContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 411px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
	gap: 20px;
	grid-auto-rows: 250px;
	height: 880px;
	padding: 0 40px 40px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export { StyledContainer, StyledEmptyContainer };
